import { boot } from "quasar/wrappers";
import { axios, WebApi } from "src/extensions/api";
import { MyPageResponseHandler } from "~/extensions/api/MyPageResponseHandler";
export default boot(async ({ app, router }) => {
    WebApi.configure(config => {
        config.baseURL = "./api";
    });
    // for use inside Vue files (Options API) through this.$axios and this.$api
    app.config.globalProperties.$axios = axios;
    // ^ ^ ^ this will allow you to use this.$axios (for Vue Options API form)
    //       so you won't necessarily have to import axios in each vue file
    app.config.globalProperties.$http = WebApi.http;
    WebApi.responseHandler = new MyPageResponseHandler(router);
    await WebApi.antiForgery.refresh();
    // ^ ^ ^ this will allow you to use this.$api (for Vue Options API form)
    //       so you can easily perform requests against your app's API
});
